"use client"
import React, {useState, useEffect} from 'react'
import {MdExpandLess} from "@react-icons/all-files/md/MdExpandLess";
import {MdExpandMore} from "@react-icons/all-files/md/MdExpandMore";
import Form from "react-bootstrap/Form";
import {useTekstClient} from "../../../../hooks/useTekstClient";
import {useSearchParams} from "next/navigation";
import useSWRImmutable from 'swr/immutable'
import {useSetSearchParams} from "../../../../hooks/useSetSearchParams";





export const FilterKenmerk = () =>{
    const fetchKenmerk = (url) => fetch(url, {credentials: 'include'}).then((res) => {
        return res.json()
    });

    const {tekst} = useTekstClient()
    const [expand, setExpand] = useState(true)
    const searchParams = useSearchParams()
    const {deleteParam, updateParam, setParams} = useSetSearchParams()
    const isReleaseNote = searchParams.get('inhoud') === 'release'

    const { data, error, isLoading } = useSWRImmutable(`${process.env.NEXT_PUBLIC_BACKEND}/api/releasenote/topdesk/kenmerk`, fetchKenmerk);
    const [filterKenmerk, setFilterKenmerk] = useState([])


    useEffect(()=>{
        if(isLoading || !data) return
        let paramSoort = searchParams.get('kenmerk') ? searchParams.get('kenmerk').split(',').map(x=> parseInt(x)) : [];
        const updatedKenmerk = [...data].map(item =>{
            let copyItem = {...item}
            copyItem.checked = paramSoort.includes(item.id)
            return copyItem
        })

       setFilterKenmerk(updatedKenmerk)
    },[data])


    const handleChange = (e,id) =>{
        let modData = [...filterKenmerk].map(item => {
            if(item.id === id){
                item.checked = e.target.checked
            }
            return item
        })
        let dataParams =  modData.filter(x=> x.checked)
        dataParams.length > 0  ? setParams([{name: 'kenmerk', value: dataParams.map(x=> x.id).join(',')}]) : deleteParam('kenmerk')
    }



    return isReleaseNote && <div>
        <b className={'cursor-pointer'} onClick={() => setExpand(!expand)}>
            {expand
                ? <MdExpandLess />
                : <MdExpandMore />
            }
            {tekst('pagina:support:kenniscentrum:filters:kenmerk')}
        </b>
        {expand && <div className={'ml-3'} style={{position: "relative"}}>
            {filterKenmerk.length > 0 && filterKenmerk.map(item =>{
                return <Form.Check
                    key={item.id}
                    type={'checkbox'}
                    id={`checkbox-soort-${item.id}`}
                    checked={item.checked}
                    label={item.kenmerk}
                    onChange={(e)=>{handleChange(e,item.id)}}
                />
            })}
        </div>

        }
        <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`} />
    </div>
}